"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const SVGComponent = (props) => (React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("g", Object.assign({ fill: "none" }, props),
        React.createElement("path", { d: "M8.00065 0.083374C3.63398 0.083374 0.0839844 3.63337 0.0839844 8.00004C0.0839844 12.3667 3.63398 15.9167 8.00065 15.9167C12.3673 15.9167 15.9173 12.3667 15.9173 8.00004C15.9173 3.63337 12.3673 0.083374 8.00065 0.083374ZM8.00065 14.6667C4.32565 14.6667 1.33398 11.675 1.33398 8.00004C1.33398 4.32504 4.32565 1.33337 8.00065 1.33337C11.6757 1.33337 14.6673 4.32504 14.6673 8.00004C14.6673 11.675 11.6757 14.6667 8.00065 14.6667Z" }),
        React.createElement("path", { d: "M5.99102 6.09167H4.41602V10.8333H5.99102V6.09167Z" }),
        React.createElement("path", { d: "M5.21784 3.80811C4.67617 3.80811 4.32617 4.15811 4.32617 4.62477C4.32617 5.09144 4.66784 5.44144 5.20117 5.44144H5.20951C5.75951 5.44144 6.10117 5.07477 6.10117 4.62477C6.09284 4.15811 5.75951 3.80811 5.21784 3.80811Z" }),
        React.createElement("path", { d: "M9.86719 5.9834C9.02552 5.9834 8.65885 6.44173 8.44219 6.76673V6.09173H6.86719C6.89219 6.5334 6.86719 10.8334 6.86719 10.8334H8.44219V8.1834C8.44219 8.04173 8.45052 7.90007 8.49219 7.80007C8.60885 7.51673 8.86719 7.22506 9.30052 7.22506C9.86719 7.22506 10.1005 7.6584 10.1005 8.30007V10.8417H11.6755V8.12506C11.6755 6.66673 10.9005 5.99173 9.85885 5.99173L9.86719 5.9834Z" }))));
exports.default = SVGComponent;
//# sourceMappingURL=linkedin.js.map